import { render } from "./ProjectDistribution.vue?vue&type=template&id=ea74ccd2&ts=true"
import script from "./ProjectDistribution.vue?vue&type=script&lang=ts"
export * from "./ProjectDistribution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__